import React from "react"
import PropTypes from "prop-types"

import {
  StyledWraper,
  StyledText,
  StyledColorBox,
} from "./PolygonInfoLabel.styles"

const PolygonInfoLabel = ({ text, color, subType }) => {
  return (
    <StyledWraper subType={subType}>
      <StyledColorBox color={color} />
      <StyledText>{text}</StyledText>
    </StyledWraper>
  )
}

PolygonInfoLabel.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  subType: PropTypes.string,
}

PolygonInfoLabel.defaultProps = {
  subType: "",
}
export default PolygonInfoLabel
